"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScrollLayout = exports.ScrollLayoutContext = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var selectorPrefix = 'adhere-ui-flex-layout-scroll-layout';
/**
 * ScrollLayoutContext
 */
exports.ScrollLayoutContext = (0, react_1.createContext)({
  getEl: function () {
    return document.body;
  }
});
/**
 * useScrollLayout
 */
var useScrollLayout = function () {
  var result = (0, react_1.useContext)(exports.ScrollLayoutContext);
  return __assign({}, result);
};
exports.useScrollLayout = useScrollLayout;
/**
 * ScrollLayout
 * @param props
 * @return {JSX.Element}
 * @constructor
 */
var ScrollLayout = (0, react_1.memo)(function (props) {
  var children = props.children,
    className = props.className,
    style = props.style,
    scrollY = props.scrollY,
    attrs = __rest(props, ["children", "className", "style", "scrollY"]);
  var wrapRef = (0, react_1.useRef)(null);
  return react_1.default.createElement(exports.ScrollLayoutContext.Provider, {
    value: {
      getEl: function () {
        return wrapRef === null || wrapRef === void 0 ? void 0 : wrapRef['current'];
      }
    }
  }, react_1.default.createElement("div", __assign({
    ref: wrapRef
  }, attrs, {
    className: (0, classnames_1.default)(selectorPrefix, className !== null && className !== void 0 ? className : ''),
    style: __assign({
      overflowY: scrollY ? 'auto' : 'hidden'
    }, style !== null && style !== void 0 ? style : {})
  }), children));
});
ScrollLayout.displayName = 'ScrollLayout';
exports.default = ScrollLayout;